import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromCurrentUser from './current-user.reducer';

export const currentUserFeatureKey = 'current-user-feature';

export const selectCurrentUserState =
  createFeatureSelector<fromCurrentUser.CurrentUserState>(
    currentUserFeatureKey,
  );

export const selectCurrentUser = createSelector(
  selectCurrentUserState,
  fromCurrentUser.currentUser,
);

export const selectCurrentUserUuid = createSelector(
  selectCurrentUser,
  user => user?.uuid,
);
